import React from 'react';
import { ArrowRight } from 'lucide-react';

const BlogCard = ({ post }) => {
  return (
    <article className="group bg-white rounded-2xl overflow-hidden border border-[#E4E1D8] hover:border-[#0F6E56] transition-all duration-300 hover:shadow-xl transform hover:-translate-y-1">
      {/* Image */}
      <div className="relative h-56 overflow-hidden">
        <img
          src={post.image}
          alt={post.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="p-6 space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-xs font-semibold text-[#5DCAA5] uppercase tracking-wide">
            {post.category}
          </span>
          <span className="text-xs text-[#6B6B69]">{post.date}</span>
        </div>
        
        <h3 className="text-xl font-bold text-[#2C2C2A] leading-snug group-hover:text-[#0F6E56] transition-colors line-clamp-2">
          {post.title}
        </h3>
        
        <p className="text-[#6B6B69] line-clamp-3">
          {post.excerpt}
        </p>
        
        <a
          href={`/blog/${post.id}`}
          className="inline-flex items-center text-[#0F6E56] font-semibold hover:gap-2 transition-all group"
        >
          <span className="text-sm">Read More</span>
          <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
        </a>
      </div>
    </article>
  );
};

export default BlogCard;